<template>
  <!-- humans -->
  <v-img
    v-if="!$root.platform.prerenderer"
    :alt="alt"
    :aspect-ratio="aspectRatio"
    :contain="contain"
    :eager="eager"
    :gradient="gradient"
    :height="height"
    :lazy-src="lazySrc"
    :max-height="maxHeight"
    :max-width="maxWidth"
    :min-height="minHeight"
    :min-width="minWidth"
    :options="options"
    :position="position || 'center center'"
    :sizes="sizes"
    :src="src"
    :srcset="srcset"
    :transition="transition || 'fade-transition'"
    :width="width"
    @load="$emit('load')"
    @error="$emit('error')"
    >
    <slot />
    <slot name="placeholder" slot="placeholder"/>
  </v-img>
  <!-- search engines -->
  <figure v-else>
    <img :alt="alt" :src="src" :srcset="srcset" :style="{maxWidth: '100%'}"/>
    <figcaption>
      <slot />
    </figcaption>
  </figure>
</template>

<script>
export default {
  name: 'SEOVImg',
  props: ['alt', 'aspect-ratio', 'contain', 'eager', 'gradient', 'height', 'lazySrc', 'maxHeight', 'maxWidth', 'minHeight', 'minWidth', 'options', 'position', 'sizes', 'src', 'srcset', 'transition', 'width']
}
</script>
